<template>
  <!-- start slides -->
  <section id="home" class="text-center">
    <agile :arrows="false" :speed="1000" :timing="'linear'" :fade="true" :autoplay="true">
      <div class="slide slide--1" v-for="slide in slides">
        <img :src="slide.img" alt="Slide 1">
        <div class="slider-caption">
          <div class="templatemo_homewrapper">
            <h1 class="wow fadeInDown" data-wow-delay="2000">{{slide.title}}</h1>
            <h2 class="wow fadeInDown" data-wow-delay="2000">
              <span v-html="slide.info"></span>
            </h2>
            <p v-html="slide.details"></p>
            <a v-scroll-to="'#' + slide.href" class="smoothScroll btn btnS btn-Kirnil wow fadeInDown" data-wow-delay="2000">{{slide.urlTitle}}</a>
          </div>
        </div>
      </div>
    </agile>
  </section>
  <!-- end slides -->
</template>
<script>
  import chromecastImages from '../../lib/chromecast.json'
  export default {
    name: 'slides',
    data () {
      return {
        slides: [
          {
            title: 'Automatic printer counters',
            info: 'Collect printers counters automatically & schedule printer counters reports',
            details: '',
            urlTitle: 'Try Printer Counters',
            href: 'service',
            img: '../../../static/img/slides/1.jpg'
          },
          {
            title: 'MIBs data collection via SNMP',
            info: 'Accurate Print Usage Reporting Based on Printers MIBs  (SNMP Data Collection)',
            details: '',
            urlTitle: 'Technology',
            href: 'divider',
            img: '../../../static/img/slides/2.jpg'
          },
          {
            title: 'usage report is based firmware (MIBs)',
            info: 'MIB objects are accessed through the Simple Network Management Protocol (SNMP)',
            details: '',
            urlTitle: 'Our Solutions',
            href: 'portfolio',
            img: '../../../static/img/slides/3.jpg'
          },
          {
            title: 'Charge clients of Managed Print Services',
            info: 'track and monitor the status of printers & automatically collect printer counters data.',
            details: 'Server-Side Development | Client-Side Development | Mobile Development | API Development | UI/UX',
            urlTitle: 'Try Printer Counters',
            href: 'divider',
            img: '../../../static/img/slides/4.jpg'
          },
          {
            title: 'custom affordable prices',
            info: 'Plan your budget on the go..',
            details: '',
            urlTitle: 'Contact Us',
            href: 'contact',
            img: '../../../static/img/slides/3.jpg'
          }
        ]
      }
    },
    computed: {
      active () {
        return this.activeMenu === 'HOME'
      }
    },
    methods: {
      getRandomImage () {
        let vm = this
        let image = chromecastImages[Math.floor(Math.random() * chromecastImages.length)]
        console.log(image)
        vm.checkImageURL(image.url).then((res) => {
          console.log(res)
          return image
        }).catch((err) => {
          console.log(err)
          vm.getRandomImage()
        })
      },
      checkImageURL (url) {
        // return (url.match(/\.(jpeg|jpg|gif|png)$/) != null)
        return new Promise(function (resolve, reject) {
          let timeout = 5000
          let timer
          let img = new Image()
          img.onerror = img.onabort = function () {
            clearTimeout(timer)
            reject('error')
          }
          img.onload = function () {
            clearTimeout(timer)
            resolve('success')
          }
          timer = setTimeout(function () {
            // reset .src to invalid URL so it stops previous
            // loading, but doesn't trigger new load
            img.src = '//!!!!/test.jpg'
            reject('timeout')
          }, timeout)
          img.src = url
        })
      }
    }
  }
</script>
<style>
  .btnS {
    background-color: #367fa9 !important;
    color: #fff;
  }

  a.btnS:hover {
    color: #000 !important;
    font-weight: bold;
  }

  .agile__actions{
    display: none!important;
  }

  .agile__dots {
    bottom: 10px;
    flex-direction: column;
    right: 30px;
    position: absolute;
  }

  .agile__dot {
    margin: 5px 0;
  }

    .agile__dot button {
      background-color: transparent;
      border: 1px solid #fff;
      cursor: pointer;
      display: block;
      height: 10px;
      font-size: 0;
      line-height: 0;
      margin: 0;
      padding: 0;
      transition-duration: 0.3s;
      width: 10px;
    }

    .agile__dot--current button, .agile__dot:hover button {
      background-color: #fff;
    }

  .slide {
    display: block;
    height: 700px;
    -o-object-fit: cover;
    object-fit: cover;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// slides.vue?81b8c95c